module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-MorningCanoe-Web-1280.34cfd023.jpg";